import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTaskGroup } from 'api/task-groups.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { TaskGroup } from 'models/task-groups.model';

export const useTaskGroupsCreateQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate, data } = useMutation({
    mutationFn: (group: Omit<TaskGroup, 'id' | 'createdAt' | 'updatedAt'>) =>
      createTaskGroup({
        name: group.name,
        question: group.question,
        order: group.order,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taskGroups'] });
      toast.success('Group has been created successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate, data };
};
